import { graphql } from 'gatsby';
import Img from 'gatsby-image';
import { Anchor } from '@twilio-paste/anchor';
import { Box } from '@twilio-paste/box';
import { Heading } from '@twilio-paste/heading';
import { ListItem, OrderedList, UnorderedList } from '@twilio-paste/list';
import { DoDont, Do, Dont } from "../../../../src/components/DoDont";
import { Codeblock } from "../../../../src/components/codeblock";
import { SidebarCategoryRoutes } from "../../../../src/constants";
import Changelog from '@twilio-paste/list/CHANGELOG.md';
import * as React from 'react';
export default {
  graphql,
  Img,
  Anchor,
  Box,
  Heading,
  ListItem,
  OrderedList,
  UnorderedList,
  DoDont,
  Do,
  Dont,
  Codeblock,
  SidebarCategoryRoutes,
  Changelog,
  React
};